export const clientData = [
    {id:1,name:'Siva',company:'tech',email:'si@gmail.com',phone:88737671637,location:'vellore'},
    {id:2,name:'Pavi',company:'non-It',email:'p@gmail.com',phone:56418724691,location:'Ranipet'}
]